<template>
  <popup :close-action="handleClose">
    <template v-slot:content>
      <div class="pay-on-web-popup-content">
        <slot name="icon" />
        <slot name="title" />
        <div class="popup-subtitles">
          <slot name="subtitles" />
        </div>
        <ol class="popup-bullets">
          <slot name="bullets" />
        </ol>
        <div class="popup-button">
          <slot name="button" />
        </div>
      </div>
    </template>
  </popup>
</template>

<script>
import BaseUI from '@riseupil/base-ui';

export default {
  name: 'PayOnWebPopup',
  components: {
    Popup: BaseUI.Popup,
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
@import "~@riseupil/base-ui/src/scss/spacings";

.pay-on-web-popup-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: right;
  font-family: SimplerPro;
}
.popup-icon {
  width: 90px;
  align-self: flex-start;
  margin-top: $ri-spacing-xxl;
  margin-bottom: $ri-spacing-ml;
}
.popup-title {
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
  margin-bottom: 32px;
  width: 100%;
}
.popup-subtitles {
  font-size: 16px;
  line-height: 1.5;
  text-align: right;
  margin-bottom: $ri-spacing-ml;
}
.bold {
  font-weight: bold;
}
.popup-bullets {
  width: 100%;
  padding-right: 0;
  padding-left: 0;
  list-style-type: none;
  counter-reset: bullet;
}
.popup-bullets > li {
  counter-increment: bullet;
  margin-bottom: $ri-spacing-m;
  position: relative;
  font-size: 15px;
  display: block;
  text-align: right;
}
.popup-bullets > li:before {
  content: counter(bullet);
  background: #e6f0ff;
  color: #5b8def;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 15px;
  margin-bottom: 8px;
  margin-right: 0;
}
.popup-button {
  font-size: 16px !important;
}
</style>
